import { SpreadsheetGrid } from "@components/spreadsheet/SpreadsheetGrid";
import { CellType } from "@components/spreadsheet/cells";
import type {
    ColumnDef,
    SpreadsheetCell,
    SpreadsheetData,
} from "@components/spreadsheet/types";
import styles from "../SpreadsheetPlayground.module.scss";
import { formatSumAmount } from "./spreadsheetPlaygroundShared";

export const PINNED_RESIZE_HINT =
    "Drag a header handle to resize, including pinned columns. Double-click a handle to restore the default track. Click a cell to edit.";

const COLUMNS: ColumnDef[] = [
    {
        field: "name",
        label: "Name",
        cellType: CellType.STRING,
        pinned: "left",
        width: 240,
    },
    {
        field: "owner",
        label: "Owner",
        cellType: CellType.STRING,
    },
    {
        field: "category",
        label: "Category",
        cellType: CellType.STRING,
    },
    {
        field: "amount",
        label: "Amount",
        cellType: CellType.NUMBER,
        pinned: "right",
        width: 160,
        isMonetary: true,
        aggregation: formatSumAmount,
    },
];

export interface PinnedAndResizableScenarioProps {
    data: SpreadsheetData;
    selectedCell: SpreadsheetCell | null;
    onChange: (data: SpreadsheetData) => void;
    onSelectedCellChange: (cell: SpreadsheetCell | null) => void;
}

export const PinnedAndResizableScenario = ({
    data,
    selectedCell,
    onChange,
    onSelectedCellChange,
}: PinnedAndResizableScenarioProps) => {
    const selectedLabel =
        selectedCell === null
            ? "None"
            : `row ${selectedCell.row + 1}, ${COLUMNS[selectedCell.col]?.label ?? "column"}`;

    return (
        <>
            <span>{PINNED_RESIZE_HINT}</span>
            <div className={styles.gridFrame}>
                <SpreadsheetGrid
                    className={styles.grid}
                    data={data}
                    columns={COLUMNS}
                    onChange={onChange}
                    onSelectedCellChange={onSelectedCellChange}
                    stickyHeader
                    overflow="auto"
                    showTotalsRow
                    enableColumnResizing
                />
            </div>
            <div className={styles.output}>
                <span>State</span>
                <pre role="status" aria-live="polite">
                    {`Rows: ${data.length}\nSelected: ${selectedLabel}`}
                </pre>
            </div>
        </>
    );
};
